import React from 'react';

const CCView = () => {
	return <div>CCView</div>;
};

export default CCView;
